/**
 * Interface dictionary: English.
 * Keys must match ru.js. Only UI strings; filter values sent to API remain canonical (Russian).
 */
export default {
  header_filters: 'Filters',
  header_done: 'Apply',
  filters_close: 'Close filters',
  header_city_title: 'Select city',
  header_language: 'Language',
  header_outreach: 'Outreach',
  header_outreach_title: 'Telegram outreach dashboard (admin)',
  header_debug: 'Debug',
  header_debug_title: 'Map debug mode (same as ?debug= in the URL): geocoding internals, previous coordinates and hidden ads',
  loading: 'Loading filters…',

  placeholder_min: 'min',
  placeholder_max: 'max',
  common_any_value: 'Any',
  common_yes: 'Yes',
  common_no: 'No',
  common_any_type: 'Any type',
  common_any_type_plot: 'Any plot type',
  common_any_type_house: 'Any house type',
  common_any_layout: 'Any layout',
  common_any_bathroom: 'Any bathroom',
  common_any_renovation: 'Any renovation',
  common_gas_any: 'With or without gas',
  common_any_heating: 'Any heating',
  common_any_purpose: 'Any purpose',
  common_any_location: 'Any location',
  common_any_finishing: 'Any finishing',
  common_any_facade: 'Any facade',
  common_any_parking: 'Any parking',
  common_any_stage: 'Any stage',
  common_any_class: 'Any class',

  filters_price: 'Price',
  filters_commission_up_to: 'Commission up to',
  filters_rooms: 'Number of rooms',
  filters_area_total: 'Total area, m²',
  filters_area_living: 'Living area, m²',
  filters_area_kitchen: 'Kitchen area, m²',
  filters_area_usable: 'Usable area, m²',
  filters_plot_area: 'Plot area, sotki',
  filters_floor: 'Floor',
  filters_floors_total: 'Floors in building',
  filters_ceiling: 'Ceiling height, m',
  filters_year_built: 'Year built',
  filters_housing_type: 'Housing type',
  filters_building_type: 'Building type',
  filters_layout: 'Layout',
  filters_bathroom: 'Bathroom',
  filters_furnished: 'Furnished',
  filters_renovation: 'Renovation',
  filters_gas: 'Gas',
  filters_features_inside: 'In apartment',
  filters_features_inside_commercial: 'In premises',
  filters_features_nearby: 'Nearby',
  filters_plot_features: 'On plot / in house',
  filters_house_conditions: 'House condition',
  filters_water: 'Water',
  filters_heating: 'Heating',
  filters_communications: 'Communications',
  filters_realty_type: 'Property type',
  filters_house_location: 'Location',
  filters_land_purpose: 'Purpose',
  filters_plot_type: 'Plot type',
  filters_garage_type: 'Type',
  filters_garage_purpose: 'Purpose',
  filters_commercial_location: 'Location',
  filters_commercial_has_plot: 'Plot',
  filters_electricity: 'Electricity',
  filters_has_parking: 'Parking',
  filters_house_type: 'House type',
  filters_housing_class: 'Housing class',
  filters_blocks_count: 'Number of blocks',
  filters_finishing: 'Finishing',
  filters_facade: 'Facade',
  filters_parking_type: 'Parking',
  filters_construction_stage: 'Construction stage',
  filters_parking_slots_from: 'Parking slots from',
  filters_installment: 'Installment',
  filters_mortgage: 'Mortgage',

  balloon_no_photo: 'No photo',
  carousel_prev: 'Previous',
  carousel_next: 'Next',
  debug_section_title: 'Debug data',
  debug_description: 'Description',
  debug_geocoded_by: 'Geocoded by',
  debug_geocoded: 'Geocoded',
  debug_landmarks_anomalies: 'Landmarks anomalies',
  debug_landmarks_approved: 'Landmarks approved',
  debug_geocoding_requests: 'Geocoding requests',
  debug_change_link: 'Personal change-location link',
  debug_regeocode_button: 'Regeocode',
  debug_regeocode_status_running: 'Regeocoding...',
  debug_regeocode_status_done: 'Done: geodata updated',
  debug_regeocode_status_error: 'Regeocode failed',
  debug_regeocode_status_unchanged: 'Coordinates are unchanged',
  debug_regeocode_flash_unchanged: 'Coordinates are unchanged',
  debug_toggle_on: 'Debug mode is on',
  debug_toggle_off: 'Debug mode is off',

  // Change location mode (?change=...)
  change_button: 'Change location',
  change_pick_hint: 'Click on the map to pick a new location for the listing',
  change_cancel: 'Cancel',
  change_confirm_title: 'Save the new location?',
  change_confirm_hint: 'You can drag the point to fine-tune it',
  change_confirm: 'Confirm',
  change_saving: 'Saving...',
  change_save_done: 'Location updated',
  change_save_error: 'Failed to save location',
  change_hide_button: 'Hide',
  change_show_button: 'Show',
  change_hide_confirm_title: 'Hide this listing?',
  change_show_confirm_title: 'Show this listing?',
  change_hide_confirm_hint: 'The listing will no longer appear on the map for regular users',
  change_show_confirm_hint: 'The listing will be visible to everyone again',
  change_hide_done: 'Listing hidden',
  change_show_done: 'Listing shown',
  change_hide_error: 'Failed to change visibility',
  balloon_hidden_banner: 'Listing hidden',

  // One-time link authorization
  auth_menu_title: 'Profile',
  auth_logout: 'Log out',
  auth_login_success: 'Signed in — your ads are highlighted in orange. Open your ad to change its location or hide it',
  auth_login_success_no_hide: 'Signed in — your ads are highlighted in orange. Open your ad to change its location',
  auth_login_error: 'Login link is invalid or expired',
  auth_logged_out: 'Signed out',

  // Ad author editing their own ad (signed in via personal login link)
  author_card_hint: 'This is your ad: you can change its location or hide it from the map',
  author_card_hint_no_hide: 'This is your ad: you can change its location',
  author_save_done: 'Thank you! Your ad location has been updated',
  author_hide_done: 'The ad is hidden from the map. Use “Show” to bring it back',
  author_session_expired: "Couldn't save: your sign-in has expired. Open the link from the message again",

  city_andijan: 'Andijan',
  city_bukhara: 'Bukhara',
  city_guliston: 'Guliston',
  city_jizzakh: 'Jizzakh',
  city_karshi: 'Qarshi',
  city_navoi: 'Navoiy',
  city_namangan: 'Namangan',
  city_nukus: 'Nukus',
  city_samarkand: 'Samarkand',
  city_tashkent: 'Tashkent',
  city_termez: 'Termez',
  city_urgench: 'Urgench',
  city_fergana: 'Fergana',

  // Option values moved to locales/opt/*.js
}
